import React from 'react';
import { FiMessageCircle } from 'react-icons/fi';

const Toggle = ({ count = 0, onToggle = () => {}, expanded = false, 'aria-controls': ariaControls }) => {
  return (
    <button
      type="button"
      onClick={onToggle}
      className="c-context-menu__toggle"
      aria-label="Messages"
      aria-haspopup="menu"
      aria-expanded={expanded}
      aria-controls={ariaControls}
    >
      <FiMessageCircle className="c-context-menu__toggle__icon" aria-hidden="true" />
      {count > 0 ? <div className="c-badge c-conversations__badge">{count > 9 ? '9+' : count}</div> : <></>}
    </button>
  );
};

export default Toggle;
